import React from "react";
import { Col, Row } from "react-bootstrap";

// img
import g1 from "../../../../../Assets/images/g1.png";
import Chart from "react-apexcharts";

const BookingStatusTab = (props) => {
  const {
    cancelBooking = 0,
    ongoingBooking = 0,
    completeBooking = 0,
    upcomingBooking = 0,
  } = props;
  const series = [
    upcomingBooking,
    ongoingBooking,
    completeBooking,
    cancelBooking,
  ];

  const options = {
    chart: {
      type: "pie",
    },
    labels: ["Pending", "Confirmed", "Completed", "Canceled"],
    legend: {
      position: "right",
    },
  };
  return (
    <>
      <Row className="justify-content-center">
        <Col lg="12">
          <div className="cardCstm p-3 rounded border">
            <div className="cardHead m-0 pb-2">
              <h6 className="m-0 fw-sbold themeBlue">Booking Status </h6>
            </div>
            <div className="graph text-center d-flex justify-content-center w-100">
              {/* <img
                src={g1}
                alt=""
                className="img-fluid"
                style={{ maxWidth: 500 }}
              /> */}

              <div
                style={{
                  width: "400px",
                }}
              >
                <Chart
                  options={options}
                  series={series}
                  type="pie"
                  className="w-100"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BookingStatusTab;
